import { render, staticRenderFns } from "./More.vue?vue&type=template&id=70fa2bed&scoped=true&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"
import style0 from "./More.vue?vue&type=style&index=0&id=70fa2bed&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa2bed",
  null
  
)

export default component.exports